export const SET_USER_PREVIOUS_RESULT = "SET_USER_PREVIOUS_RESULT";

export const setUserPreviousResult = (response) => {
  return {
    type: SET_USER_PREVIOUS_RESULT,
    payload: response,
  };
};
